export enum Color {
  White = "#FFF",
  Black = "#000",

  Gray000 = "#F8F8F9",
  Gray100 = "#DCDCDC",
  Gray200 = "#BCBCBC",
  Gray300 = "#A1A1A1",
  Gray400 = "#868686",
  Gray500 = "#5E5E5E",
  Gray600 = "#4A4A4A",
  Gray700 = "#323232",
  Gray800 = "#232323",
  Gray900 = "#1A1A1A",

  Red000 = "#feeff2",
  Red100 = "#ffd1d7",
  Red200 = "#fa9da5",
  Red300 = "#f77c83",
  Red400 = "#fc515a",
  Red500 = "#fc3d46",
  Red600 = "#f33340",
  Red700 = "#e02839",
  Red800 = "#d32032",
  Red900 = "#c40d24",

  Orange000 = "#fff9f2",
  Orange100 = "#ffe8cc",
  Orange200 = "#ffd8a8",
  Orange300 = "#ffc078",
  Orange400 = "#ffa94d",
  Orange500 = "#ff922b",
  Orange600 = "#fd7e14",
  Orange700 = "#f76707",
  Orange800 = "#e8590c",
  Orange900 = "#d9480f",

  Blue000 = "#EEF4FE",
  Blue100 = "#CCDEFC",
  Blue200 = "#9EC0FA",
  Blue300 = "#78A6F8",
  Blue400 = "#508CF7",
  Blue500 = "#1D63F6",
  Blue600 = "#144CD2",
  Blue700 = "#0932A6",
  Blue800 = "#07217B",
  Blue900 = "#081954",

  Green500 = "#00b79d",
}

export const isLightMode = true;

export const white = "#FFFFFF";
export const black = "#010101";
export const light900 = "#292929";
export const light800 = "#575757";
export const light700 = "#808080";
export const light600 = "#A3A3A3";
export const light500 = "#BDBDBD";
export const light400 = "#D1D1D1";
export const light300 = "#E0E0E0";
export const light200 = "#F0F0F0";
export const light100 = "#FAFAFA";

export const dark900 = "#EBEBEB";
export const dark800 = "#C7C7C7";
export const dark700 = "#999999";
export const dark600 = "#757575";
export const dark500 = "#575757";
export const dark400 = "#3D3D3D";
export const dark300 = "#292929";
export const dark200 = "#1A1A1A";
export const dark100 = "#0F0F0F";

export const orange600 = "#FD7E14";

export const primaryColor = orange600;

export const text01 = isLightMode ? light900 : dark900;
export const text02 = isLightMode ? light800 : dark800;

export const uiBackground01 = isLightMode ? white : black;
export const ui01 = isLightMode ? light100 : dark100;
export const ui02 = isLightMode ? white : black;

export const border01 = isLightMode ? light200 : dark200;
export const focus01 = isLightMode ? light900 : dark900;
